import React, { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

interface IProps extends WithStyles<typeof styles> {
  adornment: ReactNode;
  approvalKey: string;
}

const styles = ({ custom, typography }: Theme) =>
  createStyles({
    settings: {
      marginTop: -2,
      padding: '0px 16px 8px',
      paddingRight: 0,
      backgroundColor: custom.palette.grey4,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
    },
    text: {
      color: custom.palette.grey1,
      fontSize: typography.pxToRem(12),
    },
    value: {
      textTransform: 'uppercase',
    },
  });

const Settings: FC<IProps> = ({ classes, adornment, approvalKey }) => (
  <div className={classes.settings}>
    <Grid container alignItems="center">
      <Grid item xs>
        <Typography className={classes.text}>
          <Trans i18nKey="groups:autoApproveSetting" /> -{' '}
          <span className={classes.value}>
            <Trans i18nKey={approvalKey} />
          </span>
        </Typography>
      </Grid>
      <Grid item>{adornment}</Grid>
    </Grid>
  </div>
);

export default withStyles(styles)(Settings);
